// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/tabs/style/index.less
// module id = 1068
// module chunks = 0